import {useState} from "react";
import AppConfig from "../../../../../AppConfig";
import React from "react";
import QRCodeModal from "../../../../../custom-packages/QRCodeWrapper/QRCodeModal";
import {View} from "../../../../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import ContextualActionBar from "../../../../../custom-packages/contextual-action-bar/ContextualActionBar";
import {TagButton} from "../../../../../custom-packages/react-button-package/ButtonPackage";

const TMenuEditorTopBar = {
    // English
    "enUS": {
        'TO_MENU': 'See Menu',
        'QR_CODE': 'QR Code',
    },
    // Spanish
    "esMX": {
        'TO_MENU': 'Ver Menú',
        'QR_CODE': 'Código QR',
    }
}


const useViewport = () => {
    const [width, setWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleWindowResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleWindowResize);
        // Return a function from the effect that removes the event listener
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    // Determine whether the current width of the viewport is less than 500 pixels
    return {isMobile: width < 576};
}

const MenuEditorTopBar = ({menuID}) => {
    const [isQrModalOpen, setIsQrModalOpen] = useState(false);

    const {isMobile} = useViewport();

    return <ContextualActionBar
        style={{
            justifyContent: 'flex-end',
        }}
    >
        {
            isMobile ?
                <View style={{marginRight: 7}}>
                    <TagButton
                        text={TMenuEditorTopBar[AppConfig.lang].TO_MENU}
                        onPress={() => {
                            window.open('/public/menu/' + menuID, '_blank');
                        }}
                    />
                </View>
                :
                null
        }
        <TagButton
            text={TMenuEditorTopBar[AppConfig.lang].QR_CODE}
            onPress={() => {
                setIsQrModalOpen(true)
            }}
        />
        <QRCodeModal
            visible={isQrModalOpen}
            onRequestClose={() => setIsQrModalOpen(false)}
            menuID={menuID}
        />
    </ContextualActionBar>
}

export default MenuEditorTopBar;